export default __webpack_public_path__ + "static/opengraph-9719f6cf781863fb4775b1e8f4f0664c.jpg";